<script>
import OrdersApi from "@/services/orders-api";

export default {
  mounted(){
    this.getMonthlyDiscount()
  },
  methods:{
    getMonthlyDiscount(){
      OrdersApi.getMonthlyDiscount().then(
        (result)=>{
          if(result){
              this.series_month[0].data = result
              this.loading_sources=true

          }
        }
      )
    },
    getYearlyDiscount(){
      OrdersApi.getYearlyDiscount().then(
        (result)=>{
          if(result){
            this.series_year[0].data=result
            this.loading_sources=true
          }
        }
      )
    }
  },
  data() {
    return {
      loading_sources:false,
      series_month: [
        {
          name: "Total des remises",
          data: []
        },
        
      ],

        series_year: [
        {
          name: "Total des remises",
          data: []
        },
        
      ],
      chartOptions_month: {

        chart: {
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "10%",
            endingShape: "rounded"
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ]
        },
        colors: ["#f46a6a"],
        legend: {
          position: "bottom"
        },
        fill: {
          opacity: 1
        },
        "yaxis": [{
          "labels": {
              "formatter": function (val) {
                  return val.toFixed(3)
              }
        }
    }]
      },
      chartOptions_year: {
          
        chart: {
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "5%",
            endingShape: "rounded"
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [2020,2021,2022,2023,2024,2025,2026,2027,2028,2029,2030]
        },
        colors: ["#f46a6a"],
        legend: {
          position: "bottom"
        },
        fill: {
          opacity: 1
        },
        "yaxis": [{
          "labels": {
              "formatter": function (val) {
                  return val.toFixed(3)
              }
        }
    }]
      }
    
    };
  }
};
</script>
<template>
  <div class="card    mr-xl-4 mr-lg-0  h-100 border border-light" >
    <div class="card-body p-0">
        <div class="clearfix m-4">
        <h4 class="card-title font-size-18 text-primary mb-4">Statistiques des Remises<span class="font-size-12 pl-1">(HT)</span></h4>
        <b-tabs >
          <b-tab @click="loading_sources=false ;getMonthlyDiscount();" >
            <template v-slot:title>
                <span class=" font-size-16">Mois</span>
            </template>
            <template >
              <div v-if="loading_sources"> 
                <apexchart
                    class="apex-charts"
                    type="bar"
                    height="362"
                    :series="series_month"
                    :options="chartOptions_month"
                ></apexchart>
              </div>

            </template>
          </b-tab>
          <b-tab @click="loading_sources=false ;getYearlyDiscount()" >
            <template v-slot:title>
                <span class="font-size-16">Année</span>
            </template>
            <template>
              <div v-if="loading_sources"> 
                <apexchart
                    class="apex-charts"
                    type="bar"
                    height="362"
                    :series="series_year"
                    :options="chartOptions_year"
                ></apexchart>
              </div>
            </template>
          </b-tab>
        </b-tabs>
            
        </div>


    </div>
  </div>
</template>